var isClient = require('./isClient');

/**
 * @returns {boolean} Returns true if
 */
var isMobile = isClient() && window.innerWidth < 700;
module.exports = isMobile;